export default "__VITE_ASSET__DUA$MkuZ__"